import React from 'react';
import Tooltip from 'core/components/Tooltip';
import isNil from 'lodash/isNil';
import {
  getServiceLineStatusDisplay,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/serviceLineStatus';
import {
  ServiceAllocation,
} from 'pages/Dashboard/pages/Billing/types';

type Props = {
  data?: ServiceAllocation | null;
};

export default function ServiceLineStatusBadge({
  data,
}: Props) {
  const statusDisplay = getServiceLineStatusDisplay(data);

  return !isNil(statusDisplay) ? (
    <Tooltip title={statusDisplay.tooltip}>
      <div className="bg-red-100 text-red-500 !font-semibold !text-[11px] px-2 rounded-full">
        {statusDisplay.label}
      </div>
    </Tooltip>
  ) : null;
}
